import { render, staticRenderFns } from "./ListBrand.vue?vue&type=template&id=0870afec"
import script from "./ListBrand.vue?vue&type=script&lang=js"
export * from "./ListBrand.vue?vue&type=script&lang=js"
import style0 from "./ListBrand.vue?vue&type=style&index=0&id=0870afec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports